module.exports = __webpack_public_path__ + "static/media/carousel13.a65ebec5.jpeg";